import React, { useState, useEffect, forwardRef } from 'react';
import Profile_pic from '../../assets/images/profile_pic.svg';
import '../../scss/style/review.scss';
import { useAuth } from '../../Context/AuthContext';
import ReactStars from 'react-rating-stars-component';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Reviews = forwardRef((props, ref) => {
  const [review, setReview] = useState('');
  const [rating, setRating] = useState(0); // Default rating is 0
  const { placeID } = props;
  const [userData, setUserData] = useState(null);
  const [userReviews, setUserReviews] = useState([]);
  const { addreview, getReviews, deleteReview, updatereview, addrate, getrate } = useAuth();
  const [showDeleteMenu, setShowDeleteMenu] = useState(null);
  const [editingReviewIndex, setEditingReviewIndex] = useState(null);
  const [editedReview, setEditedReview] = useState('');
  const p_ID = localStorage.getItem('profile_id');

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem('userData'));
    if (storedUserData) {
      setUserData(storedUserData);
    }
  }, []);

  useEffect(() => {
    const fetchReviewsAndRatings = async () => {
      try {
        const [reviewsResponse, ratingsResponse] = await Promise.all([
          getReviews(placeID),
          getrate(placeID)
        ]);

        const ratingsMap = ratingsResponse.data.reduce((acc, rating) => {
          acc[rating.profile_id] = rating.rate;
          return acc;
        }, {});

        const enhancedReviews = reviewsResponse.data.map(review => ({
          ...review,
          firstName: review.profiles.first_name,
          lastName: review.profiles.last_name,
          profile_id: review.profile_id,
          profile_image: review.profile_image,
          rating: ratingsMap[review.profile_id] || 0,
          timestamp: new Date(review.inserted_at).getTime()
        }));

        setUserReviews(enhancedReviews.sort((a, b) => b.timestamp - a.timestamp));
      } catch (error) {
        console.error('Error fetching reviews or ratings', error);
      }
    };

    fetchReviewsAndRatings();
  }, [getReviews, getrate, placeID]);

  const addDefaultSrc = (ev) => {
    ev.target.src = Profile_pic;
  };

  const handleReviewChange = (event) => {
    setReview(event.target.value);
  };

  const handleReviewPost = async () => {
    try {
      await addreview(placeID, review);

      const newReviewObject = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        review: review,
        inserted_at: "now",
        profile_id: p_ID,
        profile_image: userData.image_url,
        rating: rating,
        timestamp: Date.now()
      };

      setUserReviews((prevUserReviews) => [newReviewObject, ...prevUserReviews]);

      setReview('');
      setRating(rating);  // Reset the rating after posting
    } catch (error) {
      console.error('Error posting review', error);
    }
  };

  const handleDeleteReview = async (reviewID) => {
    try {
      await deleteReview(reviewID);
      setUserReviews((prevReviews) => prevReviews.filter(review => review.review_id !== reviewID));
    } catch (error) {
      console.error('Error deleting review', error);
    }
  };

  const handleEditReview = (index) => {
    setEditingReviewIndex(index);
    setEditedReview(userReviews[index].review);
  };

  const handleSaveReview = async (reviewID) => {
    try {
      await updatereview(editedReview, reviewID);
      setUserReviews((prevReviews) =>
        prevReviews.map((prevReview, index) =>
          index === editingReviewIndex
            ? { ...prevReview, review: editedReview }
            : prevReview
        ).sort((a, b) => b.timestamp - a.timestamp)
      );
      setEditingReviewIndex(null);
      setEditedReview('');
    } catch (error) {
      console.error('Error updating review', error);
    }
  };

  const handleCancelEdit = () => {
    setEditingReviewIndex(null);
    setEditedReview('');
  };

  const timeSince = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);

    let interval = seconds / 31536000; // Calculate years
    if (interval > 1) {
      return Math.floor(interval) + " years ago";
    }
    interval = seconds / 2592000; // Calculate months
    if (interval > 1) {
      return Math.floor(interval) + " months ago";
    }
    interval = seconds / 604800; // Calculate weeks
    if (interval > 1) {
      return Math.floor(interval) + " weeks ago";
    }
    interval = seconds / 86400; // Calculate days
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600; // Calculate hours
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60; // Calculate minutes
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago"; // Seconds
  };

  const handleRatingChange = async (newRating) => {
    console.log(`Rated ${newRating} stars!`);
    setRating(newRating);  // Update the state with the new rating
    try {
      await addrate(placeID, newRating);
    } catch (error) {
      console.error('Error adding rating', error);
    }
  };

  return (
    <div className='reviews'>
      <h1 className='review-form-header'>REVIEWS</h1>

      <div className='review-form'>
        {userReviews.length === 0 ? (
          <p className='no-reviews'>No reviews</p>
        ) : (
          userReviews.map((review, index) => (
            <div key={index} className='review-card'>
              <div className='review-user-info'>
                <div className='review-profile-pic'>
                  <img
                    className='review-img-pic'
                    onError={addDefaultSrc}
                    src={review.profile_id === p_ID ? userData.image_url : review.profile_image}
                    alt='profile-pic'
                  />
                </div>

                <div className='review-user-name'>
                  <span>{review.firstName} </span>
                  <span className='last-namee'>{review.lastName}</span>
                </div>
              </div>

              <div className='review-content'>
                <div className='review-overflow'>
                  {(p_ID === review.profile_id) && (
                    <div className='overflow-menu' onClick={() => setShowDeleteMenu(showDeleteMenu === index ? null : index)}>
                      &#8942;
                      {showDeleteMenu === index && (
                        <div className="dropdown-menu">
                          <ul className='dropdown-menu-list'>
                            <li><a className='edit-tag' onClick={() => handleEditReview(index)}>Edit</a></li>
                            <hr className='hz-line'></hr>
                            <li><a className='delete-tag' onClick={() => handleDeleteReview(review.review_id)}>Delete</a></li>
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className='rate-and-time'>
                  <div className="review-stars">
                    {window.innerWidth > 577 ? 
                    <ReactStars
                    count={5}
                    value={review.rating} // Use the rating from the review object
                    size={24}
                    activeColor="#ffd700"
                    edit={false}
                    />
                    :
                    <ReactStars
                    count={5}
                    value={review.rating} // Use the rating from the review object
                    size={16}
                    activeColor="#ffd700"
                    edit={false}
                    />}
                  </div>
                  <div className='time-since-posted'>
                    {review.inserted_at === "now" ? "now" : timeSince(review.inserted_at)}
                  </div>
                </div>
                

                {editingReviewIndex === index ? (
                  <textarea
                    className='newreview-textarea'
                    placeholder='Edit your review'
                    value={editedReview}
                    onChange={(event) => setEditedReview(event.target.value)}
                  />
                ) : (
                  <p>{review.review}</p>
                )}

                {editingReviewIndex === index && (
                  <div className='edit-btns'>
                    <button className='save-btn' onClick={() => handleSaveReview(review.review_id)}>Save</button>
                    <button className='cancel-btn' onClick={handleCancelEdit}>Cancel</button>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      <div ref={ref} className='user-review'>
        <div className='add-review-header-space'>
          <h2 className='add-review-header'>Add your rating and review</h2>
        </div>
        

        <div className='user-info-container'>
          {userData && (
            <div className='user-infoo'>
              <div className='profile-picc'>
                <img
                  className='img-picc'
                  onError={addDefaultSrc}
                  src={userData.image_url}
                  alt='profile-pic'
                />
              </div>

              <div className='user-nameee'>
                <span>{userData.firstName} </span>
                <span className='last-namee'>{userData.lastName}</span>
              </div>

              <div className="rating-stars">
                <ReactStars
                  key={rating}
                  count={5}
                  value={rating}
                  onChange={handleRatingChange}
                  size={24}
                  activeColor="#ffd700"
                />
              </div>
            </div>
          )}
          <textarea
            className='review-textarea'
            placeholder='Enter your review'
            value={review}
            onChange={handleReviewChange}
          />
          <button className="post-btn" onClick={handleReviewPost}>Post</button>
        </div>
      </div>
    </div>
  );
});

export default Reviews;
